module.exports = "/images/envelope.svg?3454cd7d86705b65b92fdfb160f644ba";